import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d133544e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d133544e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d133544e')) {
      api.createRecord('d133544e', component.options)
    } else {
      api.reload('d133544e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d133544e&scoped=true&", function () {
      api.rerender('d133544e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/h5/category/index.vue"
export default component.exports